import { Button } from "~components";
import { Css } from "~generated/css";

type GoogleAuthButtonProps = {
  mode?: "signIn" | "signUp";
  onClick: () => void;
};

export function GoogleAuthButton({ mode = "signIn", onClick }: GoogleAuthButtonProps) {
  const label = mode === "signIn" ? "Sign in with Google" : "Sign up with Google";

  return (
    <Button variant="secondary" xss={Css.ba.bcGray800.ifTabletAndUp.w100.$} onClick={onClick}>
      <img src="/google-icon.png" alt="Google" css={Css.sqPx(22).mr2.$} />
      {label}
    </Button>
  );
}
